import { TApplicationState } from 'shared/types/redux';

export const buildersSelector = (state: TApplicationState) => {
  return state.newbuilding.builders;
};

export function buildersWithPhonesSelector(state: TApplicationState) {
  const {
    newbuilding: { builders },
  } = state;

  if (builders) {
    return builders.filter(builder => builder.showPhone && builder.phone);
  }

  return [];
}
